import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { api, formatError } from "@/lib/api";
import { fmtDate } from "@/lib/helpers";
import { DetailShell, InfoRow, InfoGrid } from "@/components/DetailShell";
import { BtnPrimary, StatusBadge, Empty } from "@/components/primitives";
import { Printer } from "@phosphor-icons/react";
import { toast } from "sonner";

export default function DeliveryNoteDetail() {
  const { id } = useParams();
  const nav = useNavigate();
  const [dn, setDn] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get(`/delivery-notes/${id}`);
        setDn(data);
      } catch (e) { toast.error(formatError(e)); }
      finally { setLoading(false); }
    })();
  }, [id]);

  if (loading) return <div className="phizo-label">Loading delivery note…</div>;
  if (!dn) return <Empty label="Delivery note not found." />;

  return (
    <DetailShell
      overline="SALES / DELIVERY NOTE (PICKING SLIP)"
      title={dn.number}
      subtitle={`${dn.customer} · ${dn.product_name}`}
      backTo="/production"
      testId="dn-detail"
      actions={
        <>
          <StatusBadge status={dn.status} />
          <BtnPrimary onClick={() => nav(`/delivery-notes/${id}/print`)} data-testid="dn-print">
            <Printer size={12} weight="bold" /> Print
          </BtnPrimary>
        </>
      }
    >
      <InfoGrid cols={3}>
        <InfoRow label="Customer" value={dn.customer} />
        <InfoRow label="Product" value={dn.product_name} />
        <InfoRow label="Delivery Date" value={fmtDate(dn.delivery_date)} />
        <InfoRow label="Tonnes" value={`${dn.tonnes} t`} />
        <InfoRow label="Rate (USD/t)" value={typeof dn.rate_usd === "string" ? dn.rate_usd : `$ ${dn.rate_usd}`} />
        <InfoRow label="Truck Plate" value={dn.truck_plate || "—"} />
        <InfoRow label="Driver" value={dn.driver || "—"} />
        <InfoRow label="Project" value={dn.project_code || "—"} />
        <InfoRow label="Created By" value={dn.created_by_name} />
      </InfoGrid>

      {dn.notes && (
        <div className="mt-6 phizo-card p-4">
          <div className="phizo-label mb-2">Notes</div>
          <p className="text-sm whitespace-pre-wrap">{dn.notes}</p>
        </div>
      )}
    </DetailShell>
  );
}
